import { Box } from "@mui/material";
import { DotLegalCheckbox } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useCustomField } from "./customField.hooks.ts";
import { isNullOrWhitespace, setFirstLetterToLowerCase } from "../../../common/stringOperations.ts";
import { InputFieldTypeEnum } from "../../inputFields/InputFields.types.ts";

export interface CustomCheckboxProps {
    isLoading: boolean;
    entityId: string;
    entityApiPath: string;
    customInputFieldId: string;
    fieldName: string;
    fieldDescription: string | undefined;
    value: boolean;
    onChange: (changeFunc: (entity: any) => void) => void;
    readOnly?: boolean;
    isDisabled: boolean;
    errorText?: string;
    isPreview: boolean;
}

function CustomCheckbox(props: CustomCheckboxProps) {
    const { translateString } = useTranslation();
    const { onFieldChange } = useCustomField(props.entityApiPath, props.entityId, props.customInputFieldId, props.onChange);

    const value = isNullOrWhitespace(props.value?.toString()) ? false : props.value;
    return (
        <Box
            sx={{
                "& .dot-legal-checkbox": {
                    marginLeft: "-10px",
                },
            }}
        >
            <DotLegalCheckbox
                checked={value}
                label={props.fieldName}
                disabled={props.isDisabled}
                tooltip={props.fieldDescription}
                onChange={props.readOnly ? () => {} : (value) => onFieldChange(value)}
                error={!isNullOrWhitespace(props.errorText)}
                helperText={
                    props.errorText ||
                    (props.isPreview ? translateString(setFirstLetterToLowerCase(InputFieldTypeEnum[InputFieldTypeEnum.CheckboxField].toString())) : undefined)
                }
            />
        </Box>
    );
}

export default CustomCheckbox;
